let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kkWcG")).then(() => parcelRequire('9Wa6U'));